import { Box, Heading } from '@chakra-ui/react'
import SEO from '../Components/SEO';

import Slider from './Components/Home/Slider';
import Categories from './Components/Home/Categories';
import BestSeller from './Components/Home/BestSeller';
import Marque from './Components/Home/Marque';
import Slider1 from '../Assets/Sliders/Slider1.tif';
import Slider2 from '../Assets/Sliders/Slider2.jpg';
import Slider3 from '../Assets/Sliders/Slider3.jpg';
import Slider4 from '../Assets/Sliders/Slider4.jpg';
import Slider5 from '../Assets/Sliders/Slider5.jpg';

export default function Home() {
  const imgArr=[
    {url: "https://assets.gqindia.com/photos/610a86d93c2393622e230912/16:9/w_1920,c_limit/top-image-03-6.jpg", alt: "Men's formal clothing and suiting collection"},
    {url: "https://i.pinimg.com/564x/1e/06/8f/1e068ff17384ceab924508e86a57ac6b.jpg", alt: "Premium men's shirting collection"},
    {url: "https://qph.fs.quoracdn.net/main-qimg-16d624f1513d8be38b37149c3a6d2112", alt: "Ajanta Cloth House fabric collection"},
    {url: "https://www.lisaadelhi.com/wp-content/uploads/2016/08/lisaa-bridal.jpg", alt: "Women's festive and ethnic wear collection"},
    // {url: Slider5},
  ]

  return (
    // {{base:"200px",md:"300px"}}
    // Wrapper box
    <Box bgColor={"#f1f2f4"}>
      <SEO
        title="Ajanta Cloth House - Curated Clothing & Fabrics, Sirsa"
        description="Explore premium suiting, shirting, and curated ready-to-wear collections for men and women at Ajanta Cloth House in Sirsa. Visit our store or browse our featured collections online."
        path="/"
        image="https://ajantasirsa.com/og-image.png"
      />
      <Box px={6} pt={6}>
        <Heading as="h1" size="xl" color="#184a49" mb={2} fontWeight="bold">
          Clothing & Fabric Store in Sirsa
        </Heading>
        <Heading as="h2" size="xl" color="#184a49" mb={2} fontWeight="bold">
          Ajanta Cloth House - Quality Fabrics & Trusted Brands
        </Heading>
        <Heading as="h2" size="md" color="#2c7a7b" mb={4} fontWeight="medium">
          Suits, Shirting, Ethnic Wear - Curated for Every Occasion
        </Heading>
        <Box maxW={{base:'95%',md:'70%'}} color="#333" mb={6}>
          <p>
            For over five decades Ajanta Cloth House has blended tradition with refined taste. Our curated collection includes premium suiting and shirting fabrics, ready-to-wear garments and seasonal ethnic pieces sourced from trusted brands. We prioritise fabric quality, honest pricing and personalized service - whether you seek formal suiting or festive wear. Visit our Sirsa store to feel textures, request tailoring advice, and choose from a handpicked assortment selected for longevity and style. Online visitors can explore featured collections and contact us for bespoke recommendations or in-store availability.
          </p>
          <Box as="address" fontStyle="normal" mt={4}>
            <strong>Visit Ajanta Cloth House:</strong> PNB Street, Rori Bazaar, Sirsa, Haryana 125055. Open Monday to Saturday 10:00–20:00 and Sunday 11:00–18:00.{' '}
            <a href="tel:+919254322231">Call 9254322231</a>{' '}or{' '}
            <a href="https://maps.app.goo.gl/JYJ2PmfBrctkfzeN7" target="_blank" rel="noreferrer">get directions</a>.
          </Box>
        </Box>
      </Box>
      {/* img slider */}
      <Slider imgArr={imgArr}/>

      {/* Categories */}
      <Categories/>

      {/* Bestseller grid */}
      <BestSeller/>

      {/* Marque animation */}
      <Marque/>

    </Box>
  )
}
